export const truncateText = (text?: string, maxLength = 15) => {
  if (!text) return { truncatedText: '', fullText: '' };

  const trimmedText = text.trimEnd();
  if (trimmedText.length > maxLength) {
    const truncatedText = trimmedText.slice(0, maxLength).trimEnd();
    return { truncatedText: `${truncatedText}...`, fullText: trimmedText };
  }
  return { truncatedText: trimmedText, fullText: '' };
};
